import cx from 'classnames';
import { default as React, useEffect } from 'react';
import { connect } from 'react-redux';
import ResizeDetector from 'react-resize-detector';
import { Switch, withRouter } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import { client } from '../../services';
import { getItem } from '../../utils/storage';
import RoutePrivate from './RoutePrivate';
import RoutePublic from './RoutePublic';

const AppMain = () => {
  const user_current = getItem('USER_CURRENT');

  useEffect(() => {
    try {
      // console.log('App user_current', user_current);
      if (user_current) {
        client.setHeader('token', `${user_current.token}`);
      } else {
      }
    } catch (error) { }
  }, []);

  return (
    <>
      <Switch>
        {user_current && <RoutePrivate />}
        <RoutePublic />
      </Switch>
      <ToastContainer />
    </>
  );
};


class Main extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      closedSmallerSidebar: false,
    };
  }

  render() {
    let {
      colorScheme,
      enableFixedHeader,
      enableFixedSidebar,
      enableFixedFooter,
      enableClosedSidebar,
      closedSmallerSidebar,
      enableMobileMenu,
      enablePageTabsAlt,
    } = this.props;

    return (
      <ResizeDetector
        handleWidth
        render={({ width }) => (
          <div className={cx(
            'app-container app-theme-' + colorScheme,
            { 'fixed-header': enableFixedHeader },
            { 'fixed-sidebar': enableFixedSidebar || width < 1250 },
            { 'fixed-footer': enableFixedFooter },
            { 'closed-sidebar': enableClosedSidebar || width < 1250 },
            {
              'closed-sidebar-mobile': closedSmallerSidebar || width < 1250,
            },
            { 'sidebar-mobile-open': enableMobileMenu },
            { 'body-tabs-shadow-btn': enablePageTabsAlt }
          )}><AppMain /></div>
        )}
      />
    );
  }
}

const mapStateToProp = (state) => {
  return {
    colorScheme: state.ThemeOptions.colorScheme,
    enableFixedHeader: state.ThemeOptions.enableFixedHeader,
    enableMobileMenu: state.ThemeOptions.enableMobileMenu,
    enableFixedFooter: state.ThemeOptions.enableFixedFooter,
    enableFixedSidebar: state.ThemeOptions.enableFixedSidebar,
    enableClosedSidebar: state.ThemeOptions.enableClosedSidebar,
    enablePageTabsAlt: state.ThemeOptions.enablePageTabsAlt,
  };
};

export default withRouter(connect(mapStateToProp)(Main));
